import axios from "axios";
import { urlLastPublications } from "./services.config";

export let getLastPublicationsList = function (amount: number) {
    return new Promise((resolve, reject) => {
        resolve(axios.get(urlLastPublications(amount)));
    })
}
